import { Link, useLocation } from "react-router-dom";
import "../styles/Sidebar.css";

function Sidebar() {
  const location = useLocation();

  return (
    <div className="sidebar">
      {/* Navigation items */}
      <ul className="nav-list">
        <li className={location.pathname === "/" ? "active" : ""}>
          <Link to="/">
            <span className="nav-icon">🏠</span>
            <span className="nav-text">Dashboard</span>
          </Link>
        </li>
        <li className={location.pathname === "/recipes" ? "active" : ""}>
          <Link to="/recipes">
            <span className="nav-icon">📖</span>
            <span className="nav-text">Recipes</span>
          </Link>
        </li>
        <li className={location.pathname === "/pantry" ? "active" : ""}>
          <Link to="/pantry">
            <span className="nav-icon">🧊</span>
            <span className="nav-text">My Pantry</span>
          </Link>
        </li>
        <li className={location.pathname === "/shopping" ? "active" : ""}>
          <Link to="/shopping">
            <span className="nav-icon">🛒</span>
            <span className="nav-text">Shopping Lists</span>
          </Link>
        </li>
        <li className={location.pathname === "/meal-plans" ? "active" : ""}>
          <Link to="/meal-plans">
            <span className="nav-icon">📅</span>
            <span className="nav-text">Meal Plans</span>
          </Link>
        </li>
        <li className={`feed ${location.pathname === "/feed" ? "active" : ""}`}>
          <Link to="/feed">
            <span className="nav-icon">📸</span>
            <span className="nav-text">Cooking Feed</span>
          </Link>
        </li>
        
        {/* Separated section for Sous-chef and Achievements */}
        <div className="nav-separator-line"></div>
        
        <li className={`ai-assistant ${location.pathname === "/assistant" ? "active" : ""}`}>
          <Link to="/assistant">
            <span className="nav-icon">👨‍🍳</span>
            <span className="nav-text">Sous-chef</span>
          </Link>
        </li>
        <li className={`achievements ${location.pathname === "/achievements" ? "active" : ""}`}>
          <Link to="/achievements">
            <span className="nav-icon">🏆</span>
            <span className="nav-text">Achievements</span>
          </Link>
        </li>
        <li className={`leaderboard ${location.pathname === "/leaderboard" ? "active" : ""}`}>
          <Link to="/leaderboard">
            <span className="nav-icon">📊</span>
            <span className="nav-text">Leaderboard</span>
          </Link>
        </li>
      </ul>
    </div>
  );
}

export default Sidebar;
